import { useCallback, useState } from "react";
import PanelFiltrosClientes from "../Components/Cliente/PanelFiltrosClientes";
import GridClientes from "../Components/Cliente/GridClientes";
import { usePageSubtitulo } from "../context/PageHeaderContext";

// CLIENTES-MODULO-01: módulo de clientes de facturación (listar / buscar / crear
// / editar / inactivar / reactivar). No hay borrado físico.
//
// SISTEMA-DE-DISENO · patrón LISTADO: sin migas de pan -- el título vive en la
// barra superior y el conteo se publica como subtítulo.
function Clientes() {
    const [filters, setFilters] = useState({ search: "", estado: "A" });
    const [total, setTotal] = useState(null);

    // Estable a propósito: el grid lo recibe dentro de `data` y una función
    // nueva en cada render volvería a disparar su efecto de carga.
    const handleTotal = useCallback((n) => setTotal(n), []);

    usePageSubtitulo(total === null ? "" : `${total} cliente${total === 1 ? "" : "s"}`);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <PanelFiltrosClientes onBuscar={setFilters} onLimpiar={() => setFilters({ search: "", estado: "A" })} />

                <GridClientes data={{ filters, onTotal: handleTotal }} />
            </div>
        </div>
    );
}

export default Clientes;
